import type { ReactElement } from "react";

import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/common-components/filters-panel/constants";
import { FilterChipVariant } from "app/pages/sales-intelligence/common-components/filters-panel/types/commonEnums";
import type CompanyFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/CompanyFilter/CompanyFilter";

export const CompanyFilterResult = ({
    value,
    isExpanded,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
    filter,
}: IFilterViewBaseProps<CompanyFilter>): ReactElement | null => {
    const handleDelete = (id: string) => {
        const updatedValues = value?.filter((domain) => domain !== id) ?? [];
        onFilterUpdate(updatedValues);
        onFilterValueRemove?.(updatedValues);
    };

    const chips: ChipItem[] =
        value?.map((domain) => {
            const companyObj = filter.options.find((option) => option.domain === domain);
            return {
                id: domain,
                text: companyObj ? companyObj.company : domain,
                iconSrc: companyObj?.icon ?? "",
                hipStatus: onGetLifecycleStatus?.(domain),
                variant: FilterChipVariant.Website,
            };
        }) ?? [];

    if (!chips.length) {
        return null;
    }

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chips}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                isTabExpanded={isExpanded}
                hideActionButton={!isActionEnabled}
                onDelete={handleDelete}
            />
        </FilterResultContainer>
    );
};
